// Insight.js
import axios from "axios";
import Style from "./Insight.module.css";
import { useEffect } from "react";

const Insight = () => {
  const NavigateToDashboard = async () => {
    console.log("inside NavigateToDashboard");

    const obj = {
      dashId: 4,
    };
    let payload = {
      method: "post",
      maxBodyLength: Infinity,
      url: `https://insights.getcupi.com/node-api/dashboard-url`,
      headers: {
        "x-api-key": "c729eae6-27fc-4e44-9538-08187d5f4f4b",
        "Content-Type": "application/json",
      },
      data: obj,
    };
    console.log("invoking api");

    let response = await axios.request(payload);
    console.log("response", response.data.embedUrl);
    window.open(response.data.embedUrl, '_blank');
    // window.location.assign(response.data.embedUrl)
  };
  useEffect(() => {}, []);
  return (
    <div className={Style.InsightContainerMain}>
      <div className={Style.InsightContainer}></div>
      <div className={Style.InsightContainerFortext}>
        <h1 className={Style.InsightText}>Launching on April 5th.</h1>
        <button
          onClick={() => {
            NavigateToDashboard();
          }}
        >
          NAVIGATE TO DASHBOARD
        </button>
      </div>
    </div>
  );
};

export default Insight;
